<template>
    <div class="py-2 my-2" :class="{ hidden: isPartHidden }" data-testid="search-part">
        <SearchPartHeader :result="part">
            <template #actions><slot name="actions"></slot></template>
            <template #chart><slot name="chart"></slot></template>
        </SearchPartHeader>
        <SearchPartResults v-if="part.PartResults" :parts="part.PartResults" show-distributor />
    </div>
</template>
<script setup lang="ts">
import type { PartDetailResultGroup } from "~/utils/search";

const searchIds = inject(SearchIdsInjectKey);

const isPartHidden = computed(() => !searchIds?.partKeys.value.has(part.Key));

const { part } = defineProps<{ part: PartDetailResultGroup }>();
</script>
